export default {
  name: 'ChatMessage',
  props: ['message', 'file'],
  computed: {
    getFileIcon() {
      const { file } = this.$props;
      if (file) {
        const extArray = file.split('.');
        return extArray[extArray.length - 1] === 'pdf' ? 'mdi-file-pdf-box' : 'mdi-file-image-outline';
      }
      return '';
    },
  },
};
